import React from "react";

interface Props {
  text: string;
}

export const ChatEventFormNotification = ({ text }: Props) => (
  <div
    style={{ whiteSpace: "pre-wrap", textAlign: "start" }}
    dangerouslySetInnerHTML={{ __html: text }}
  />
);
